import type { LanguageCodeType } from 'noddi-util';

export const toWidgetLocale = (language: LanguageCodeType): string => {
  switch (language) {
    case 'nb':
      return 'nb-NO';
    case 'se':
      return 'sv-SE';
    case 'en':
      return 'en-US';
    default:
      return language;
  }
};

/** BCP-47 locales the customer app supports — passed to the widget language picker. */
export const customerWidgetSupportedLocales: string[] = [
  toWidgetLocale('nb'),
  toWidgetLocale('en'),
  toWidgetLocale('se')
];
